import {AddSchema, MGLClass} from "mobx-graphlink";
import {name_general} from "../../../Utils/General/SharedPatterns";
import {Vec2} from "../../../Utils/ThreeJS/VectorStructs.js";

@MGLClass({table: "scenes"})
export class Scene {
	constructor(initialData: Partial<Scene>) {
		Object.assign(this, initialData);
	}

	id: string;
	creator: string;
	createdAt: number;

	name: string;
	tags: string[];

	url: string;
	/** as {x: percentOfWidth, y: percentOfHeight}, from bottom-left */
	square_center = new Vec2(.5, .5);
	/** 1: target-square maximally-fits into source-image, 0.5: target-square's width/height is set to half of source-image's (whichever dimension is smaller) */
	square_size = 1;

	// scene-specific stuff
	// ==========

	// todo: probably add a way (eventually) to "crop" the image to a "usable subsection", to then treat as though that were the whole image (makes using externally-hosted images more flexible)
	groundEdge_left = new Vec2(0, .5);
	groundEdge_right = new Vec2(1, .5);
	door_basePos = new Vec2(.5, .5);
	door_height = .15;
}
AddSchema("Scene", {
	properties: {
		id: {type: "string"},
		creator: {type: "string"},
		createdAt: {type: "number"},
		name: {type: "string", pattern: name_general},
		tags: {items: {type: "string"}},

		url: {type: "string"},
		square_center: {$ref: "Vec2"},
		square_size: {type: "number"},
		
		groundEdge_left: {$ref: "Vec2"},
		groundEdge_right: {$ref: "Vec2"},
		door_basePos: {$ref: "Vec2"},
		door_height: {type: "number"},
	},
});